import { useState, useEffect } from "react";
import { PCPNavStructure } from "./PCPNavStructure";
import PCPSideBar from "./PCPSideBar/PCPSideBar";
import PCPNav from "./PCPNav/PCPNav";
import PCPMainPanel from "./PCPMainPanel/PCPMainPanel";
import { useAppContext } from "../../Components/AppProvider";
import "./PCPContents.scss";
import { getRedirect, setRedirect, clearRedirect } from "./utils/redirect";
import { useSearchParams } from "react-router-dom";

function PCPContents() {
  const {
    updateOrderHistoryNav,
    setUpdateOrderHistoryNav,
    statusCountListById,
    isCountListUpdateById,
    //setCountCurrent,
    setStatusCountListById,
    setCountListUpdateById,
    setOrderListUpdate,
    isOrderListUpdate,
    customerId,
    customerProvider,
    profileChecker,
    setProfileChecker,
  } = useAppContext();
  const [searchParams] = useSearchParams();

  const [activeNav, setActiveNav] = useState(null);
  const [activeSidebarItem, setActiveSidebarItem] = useState(null);

  // 📌 always derive currentNav AFTER state
  const currentNav = PCPNavStructure.find((nav) => nav.id === activeNav);
  const hasSidebar = currentNav?.sidebar?.length > 0;
  const [countCurrent, setCountCurret] = useState({});

  // 📌 load from localStorage on mount OR when triggered externally
  useEffect(() => {
    // 🔹 1. CHECK URL PARAMS FIRST (email redirect)
    const navParam = searchParams.get("nav");
    const sideParam = searchParams.get("side");

    if (navParam !== null && sideParam !== null) {
      const navIndex = Number(navParam);
      const sideIndex = Number(sideParam);

      if (PCPNavStructure[navIndex]) {
        const selectedNav = PCPNavStructure[navIndex];
        setActiveNav(selectedNav.id);

        const sidebarItem = selectedNav.sidebar?.[sideIndex];
        if (sidebarItem) {
          setActiveSidebarItem(sidebarItem.id);
        }
      }

      // 🧼 optional: clean URL after redirect
      window.history.replaceState({}, "", "/customer-profile");
      return; // ⬅️ IMPORTANT: stop here
    }

    // 🔹 2. FALLBACK TO LOCALSTORAGE REDIRECT (existing behavior)
    const redirectState = getRedirect();
    if (redirectState) {
      const { nav, side } = redirectState;

      if (PCPNavStructure[nav]) {
        const selectedNav = PCPNavStructure[nav];
        setActiveNav(selectedNav.id);

        const sidebarItem = selectedNav.sidebar?.[side];
        if (sidebarItem) {
          setActiveSidebarItem(sidebarItem.id);
        }
      }
    }
  }, [searchParams, updateOrderHistoryNav]);

  useEffect(() => {
    if (!customerId) {
      ////console.log("customerId: ", customerId);
      return; // wait until valid customerId is loaded
    }
    let intervalId;
    const fetchCounts = async () => {
      try {
        const res = await fetch(
          `${process.env.REACT_APP_BASE_URL}api/orders/counts-by-id/${customerId}`
        );
        if (!res.ok) throw new Error("Failed to fetch counts");

        const data = await res.json();

        const newCounts = {
          unpaidCount: data.unpaidCount || 0,
          pendingCount: data.pendingCount || 0,
          partialCount: data.partialCount || 0,
          paidCount: data.paidCount || 0,
          toReceivedCount: data.toReceivedCount || 0,
          completedCount: data.completedCount || 0,
          declinedCount: data.declinedCount || 0,
          cancelledCount: data.cancelledCount || 0,
          refundedCount: data.refundedCount || 0,
        };

        // ✅ compare field-by-field
        const hasChanged = Object.keys(newCounts).some(
          (key) => newCounts[key] !== countCurrent[key]
        );

        if (hasChanged) {
          setOrderListUpdate(true);
        }

        setStatusCountListById(newCounts);
        //setCountCurrent(newCounts);
      } catch (err) {
        console.error("Error loading counts:", err);
      }
    };

    fetchCounts(); // run immediately
    intervalId = setInterval(fetchCounts, 10000);

    return () => clearInterval(intervalId);
  }, [customerId, isCountListUpdateById]);

  useEffect(() => {
    if (!currentNav) return;

    const navIndex = PCPNavStructure.findIndex((n) => n.id === activeNav);
    const sideIndex =
      currentNav.sidebar?.findIndex((s) => s.id === activeSidebarItem) ?? 0;

    setRedirect(navIndex, sideIndex);
    //console.log("🔄 Saved redirect:", getRedirect());
  }, [activeSidebarItem, activeNav]);

  return (
    <>
      <PCPNav
        activeNav={activeNav}
        onSelect={(id) => {
          setActiveNav(id);
          const nav = PCPNavStructure.find((n) => n.id === id);
          setActiveSidebarItem(nav?.sidebar?.[0]?.id || null);
        }}
      />

      <div
        className={`pcp-info-container ${
          hasSidebar ? "with-sidebar" : "full-width"
        }`}
      >
        {hasSidebar && activeNav !== "wishlist" ? (
          <PCPSideBar
            items={currentNav.sidebar}
            active={activeSidebarItem}
            onSelect={setActiveSidebarItem}
            activeMainNavId={activeNav}
            statusCountListById={statusCountListById}
            setStatusCountListById={setStatusCountListById}
            setOrderListUpdate={setOrderListUpdate}
            setCountListUpdateById={setCountListUpdateById}
            customerProvider={customerProvider}
          />
        ) : (
          ""
        )}

        <PCPMainPanel
          navId={activeNav}
          sidebarId={activeSidebarItem}
          navStructure={PCPNavStructure}
        />
      </div>
    </>
  );
}

export default PCPContents;
